const getWalletBookCdnUrl = () => process.env['WALLET_BOOK_CDN_URL'] ??
    process.env['NEXT_PUBLIC_WALLET_BOOK_CDN_URL'] ??
    process.env['REACT_APP_WALLET_BOOK_CDN_URL'] ??
    'https://dynamic-static-assets.com/wallet-book/v1/stable/wallet-book.json';

export { getWalletBookCdnUrl };
